import { render, staticRenderFns } from "./nested-draggable.vue?vue&type=template&id=32e6d81e&scoped=true"
import script from "./nested-draggable.vue?vue&type=script&lang=js"
export * from "./nested-draggable.vue?vue&type=script&lang=js"
import style0 from "./nested-draggable.vue?vue&type=style&index=0&id=32e6d81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e6d81e",
  null
  
)

export default component.exports